import { cartAdd, getCurrentCart } from '@process-creative/slate-theme-tools';

export async function checkFreeGifts(id: number) {
  const giftsTriggerEls = document.querySelectorAll<HTMLElement>(
    '[data-free-gifts-trigger-products]'
  );

  for (const giftTrigger of giftsTriggerEls) {
    const giftsTrigger = giftTrigger
      ?.getAttribute('data-free-gifts-trigger-products')
      ?.split('|');
    const giftsListEl = document.querySelector<HTMLElement>('[data-free-gifts]');
    const giftsList = giftsListEl?.getAttribute('data-free-gifts')?.split('|');
    const giftsIds = giftsList
      ? giftsList.map((product) => parseInt(product, 10))
      : null;

    const cartFetch = getCurrentCart();
    const cart = cartFetch;
    const cartItems = cart.items;
    const mapCart = giftsIds?.map((item: any) =>
      cartItems.some((cartItem: any) => cartItem.id === item)
    );

    // eslint-disable-next-line id-length
    const ifInCart = mapCart?.reduce((a: any, b: any) => a && b);
    const variablesGifts =
      giftsTrigger && giftsTrigger?.map((item: any) => item);

    return (
      variablesGifts?.includes(id.toString()) &&
      !ifInCart &&
      addFreeGift(giftsIds, giftsTrigger)
    );
  }

  return null;
}

async function addFreeGift(giftsIds: any, parentIds: any) {
  const items: any[] = [];
  if (giftsIds) {
    giftsIds?.forEach((id: number) => {
      if (!isNaN(id)) {
        items.push({
          id,
          quantity: 1,
          properties: {
            _free_gift: true,
            _free_gift_parent_ids: parentIds,
          },
        });
      }
    });
  }
  return items.length && cartAdd({ items });
}
